import { setActionableAlert, setAlertMode, setMessage, setShowAlert } from "./alert.slice"

export const closeAlert = (callback: Function) => {
    return async(dispatch: any) => {
        dispatch(setShowAlert(false))
        setTimeout(() => {
            dispatch(setAlertMode(false))
            dispatch(setMessage(''))
            dispatch(setActionableAlert(false))
        }, 300)
        await callback()
        return {code: 1, message: 'alert modal closed'}
    }
}